"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const WeekDayFilter_1 = require("../../WeekDayFilter");
const prop_types_1 = require("prop-types");
const styles_1 = require("./styles");
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../../../../lib/messages"));
const react_intl_1 = require("react-intl");
const ArrowDown_1 = __importDefault(require("@kyruus/react-ikons/ArrowDown"));
const DayOfTheWeekOption_1 = require("./DayOfTheWeekOption");
const DayOfWeekDropdown = ({ filterBy, onSelect, intl }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [focusIndex, setFocusIndex] = (0, react_1.useState)(null);
    const dayOfTheWeekItems = WeekDayFilter_1.DAYS_OF_WEEK.map((day, idx) => ({
        id: idx,
        name: day
    }));
    const handleFocusOnKeyDown = (event, index) => {
        event.preventDefault();
        if (event.code === 'ArrowDown') {
            setFocusIndex((index + 1) % dayOfTheWeekItems.length);
        }
        else if (event.code === 'ArrowUp') {
            setFocusIndex((dayOfTheWeekItems.length + index - 1) % dayOfTheWeekItems.length);
        }
    };
    const selectedDays = new Set(filterBy.dayOfWeek);
    const getDisplayValue = () => {
        if (selectedDays.size === 0 ||
            selectedDays.size === dayOfTheWeekItems.length) {
            return intl.formatMessage(messages_1.default.anyDayOfWeek);
        }
        const selectedDayList = dayOfTheWeekItems.filter((item) => selectedDays.has(item.id));
        if (selectedDayList.length > 3) {
            const count = selectedDayList.length - 3;
            return `${selectedDayList
                .map((day) => day.name)
                .slice(0, 3)
                .join(', ')}, +${count}`;
        }
        return selectedDayList.map((day) => day.name).join(', ');
    };
    const onMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    return (react_1.default.createElement(styles_1.SelectDropdownContainer, { "data-testid": "day-of-week-dropdown" },
        react_1.default.createElement(styles_1.StyledLabel, { htmlFor: "checkselect-btn" },
            react_1.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.dayOfWeek))),
        react_1.default.createElement(styles_1.StyledMenuTriggerButton, { type: "button", id: "checkselect-btn", mode: "secondary", onClick: onMenuOpen, "aria-expanded": Boolean(anchorEl), "aria-haspopup": "menu", "aria-controls": "checkselect-menu", "aria-label": intl.formatMessage(messages_1.default.ariaFilterByDayOfWeek) },
            react_1.default.createElement("span", null, getDisplayValue()),
            react_1.default.createElement(ArrowDown_1.default, null)),
        react_1.default.createElement(styles_1.StyledMenu, { keepMounted: true, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), "data-testid": "checkselect-menu", id: "checkselect-menu", anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: {
                id: 'checkselect-menu',
                disabledItemsFocusable: true
            } }, dayOfTheWeekItems.map((day, index) => {
            return (react_1.default.createElement(styles_1.StyledMenuItem, { key: day.name, "data-testid": `day-of-week-dropdown-item-${day.name}`, role: "menuitemcheckbox", "aria-checked": selectedDays.has(day.id), "aria-controls": day.id, 
                // Disabled autoFocus as we are managing focus manually for arrow up and down
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: index === focusIndex, onKeyDown: (event) => handleFocusOnKeyDown(event, index), onClick: (event) => {
                    event.preventDefault();
                    onSelect(day, selectedDays);
                }, disableRipple: true },
                react_1.default.createElement(DayOfTheWeekOption_1.DayOfTheWeekOption, { day: day, selectedDays: selectedDays, onSelect: () => onSelect(day, selectedDays) })));
        }))));
};
DayOfWeekDropdown.propTypes = {
    filterBy: (0, prop_types_1.shape)({
        dayOfWeek: prop_types_1.array
    }),
    onSelect: prop_types_1.func,
    intl: (0, prop_types_1.shape)({
        locale: prop_types_1.string.isRequired,
        formatMessage: prop_types_1.func.isRequired
    }).isRequired
};
exports.default = (0, intl_1.injectIntl)(DayOfWeekDropdown);
//# sourceMappingURL=DayOfWeekDropdown.js.map